import {
    CalendarOutlined,
    ProfileOutlined,
    TableOutlined,
    UnorderedListOutlined,
    FileImageOutlined,
    NumberOutlined,
    FontSizeOutlined,
    AlignLeftOutlined,
    CheckSquareFilled,
    PaperClipOutlined,
    HomeOutlined,
    LinkOutlined,
    ClockCircleOutlined,
    MinusOutlined,
    DownOutlined,
    ContactsOutlined,
    UserOutlined,
    StarFilled,
    AppstoreOutlined,
} from "@ant-design/icons";
import { Switch } from "antd";
import { iconColorBgColor } from "../../utils/colorBgColorMap.js";
import WidgetIcon from "./WidgetIcon.jsx";

export const newWidgets = [
    {
        id: "address",
        label: "Address",
        span: "24",
        formType: "addressField",
        icon: <WidgetIcon icon={<HomeOutlined style={{ color: iconColorBgColor["address"].color, fontSize: "1.2rem" }} />} type="address" />,
    },
    {
        id: "attachment",
        label: "Attachment",
        formType: "attachment",
        span: "24",
        icon: <WidgetIcon icon={<PaperClipOutlined style={{ color: iconColorBgColor["attachment"].color, fontSize: "1.2rem" }} />} type="attachment" />
    },
    {
        id: "checkbox",
        label: "Checkbox",
        span: "24",
        formType: "checkboxField",
        icon: <WidgetIcon icon={<CheckSquareFilled style={{ color: iconColorBgColor["checkbox"].color, fontSize: "1.2rem" }} />} type="checkbox" />
    },
    {
        id: "contact",
        label: "Contact",
        span: "24",
        formType: "contactField",
        icon: <WidgetIcon icon={<ContactsOutlined style={{ color: iconColorBgColor["info"].color, fontSize: "1.2rem" }} />} type="info" />
    },
    {
        id: "date",
        label: "Date",
        formType: "dateForm",
        span: "24",
        icon: <WidgetIcon icon={<CalendarOutlined style={{ color: iconColorBgColor["date"].color, fontSize: "1.2rem" }} />} type="date" />
    },
    {
        id: "dropdown",
        label: "Dropdown",
        formType: "dropdownField",
        span: "24",
        icon: <WidgetIcon icon={<UnorderedListOutlined style={{ color: iconColorBgColor["dropdown"].color, fontSize: "1.2rem" }} />} type="dropdown" />
    },
    {
        id: "image",
        label: "Image",
        formType: "imageForm",
        span: "24",
        icon: <WidgetIcon icon={<FileImageOutlined style={{ color: iconColorBgColor["image"].color, fontSize: "1.2rem" }} />} type="image" />
    },
    {
        id: "info",
        label: "Info",
        formType: "infoForm",
        span: "24",
        icon: <WidgetIcon icon={<ProfileOutlined style={{ color: iconColorBgColor["info"].color, fontSize: "1.2rem" }} />} type="info" />
    },
    {
        id: "link",
        label: "Link",
        span: "24",
        formType: "linkField",
        icon: <WidgetIcon icon={<LinkOutlined style={{ color: iconColorBgColor["link"].color, fontSize: "1.2rem" }} />} type="link" />
    },
    {
        id: "multipleChoice",
        label: "Multiple Choice",
        span: "24",
        formType: "multipleChoiceField",
        icon: <WidgetIcon icon={<CheckSquareFilled style={{ color: iconColorBgColor["multipleChoice"].color, fontSize: "1.2rem" }} />} type="multipleChoice" />
    },
    {
        id: "number",
        label: "Number",
        formType: "numberForm",
        span: "24",
        icon: <WidgetIcon icon={<NumberOutlined style={{ color: iconColorBgColor["number"].color, fontSize: "1.2rem" }} />} type="number" />
    },
    {
        id: "radio",
        label: "Radio",
        formType: "radioField",
        span: "24",
        icon: <WidgetIcon icon={<NumberOutlined style={{ color: iconColorBgColor["radio"].color, fontSize: "1.2rem" }} />} type="radio" />
    },
    {
        id: "rating",
        label: "Rating",
        formType: "ratingField",
        span: "24",
        icon: <WidgetIcon icon={<StarFilled style={{ color: iconColorBgColor["rating"].color, fontSize: "1.2rem" }} />} type="rating" />
    },
    {
        id: "ratingScale",
        label: "Rating Scale",
        formType: "ratingScaleField",
        span: "24",
        icon: <WidgetIcon icon={<AppstoreOutlined style={{ color: iconColorBgColor["rating"].color, fontSize: "1.2rem" }} />} type="rating" />
    },
    {
        id: "switch",
        label: "Switch",
        formType: "switchForm",
        span: "24",
        icon: <WidgetIcon icon={<div className="form-switch-element"><Switch size="small"  defaultChecked  /></div>} type="switch" />
    },    {
        id: "table",
        label: "Table",
        span: "24",
        formType: "tableForm",
        icon: <WidgetIcon icon={<TableOutlined style={{ color: iconColorBgColor["table"].color, fontSize: "1.2rem" }} />} type="table" />
    },
    {
        id: "input",
        label: "Text",
        span: "24",
        formType: "inputForm",
        icon: <WidgetIcon icon={<FontSizeOutlined style={{ color: iconColorBgColor["input"].color, fontSize: "1.2rem" }} />} type="input" />
    },
    {
        id: "textArea",
        label: "Text Area",
        span: "24",
        formType: "textAreaForm",
        icon: <WidgetIcon icon={<AlignLeftOutlined style={{ color: iconColorBgColor["textArea"].color, fontSize: "1.2rem" }} />} type="textArea" />
    },
    {
        id: "time",
        label: "Time",
        span: "24",
        formType: "timeForm",
        icon: <WidgetIcon icon={<ClockCircleOutlined style={{ color: iconColorBgColor["time"].color, fontSize: "1.2rem" }} />} type="time" />
    },
    {
        id: "user",
        label: "User",
        formType: "userForm",
        icon: <WidgetIcon icon={<UserOutlined style={{ color: iconColorBgColor["address"].color, fontSize: "1.2rem" }} />} type="address" />
        
      },
];

export const layoutWidgets = [
    {
        id: "divider",
    // Added proper label so it shows up in search results.
    label: "Divider",
        formType: "divider",
        span: "24",
        icon: <WidgetIcon icon={<MinusOutlined style={{ color: iconColorBgColor["attachment"].color, fontSize: "1.2rem" }} />} type="attachment" />
    },
    {
        id: "section",
        label: "Section",
        formType: "section",
        span: "24",
        icon: <WidgetIcon icon={<DownOutlined style={{ color: iconColorBgColor["number"].color, fontSize: "1.2rem" }} />} type="number" />
    },
]
